<template>
    <div class="components-container">
        <div class="filter-container">
            <el-input v-model="queryForm.stuCode" @keyup.enter.native="handleFilter" style="width: 200px" placeholder="学号" clearable>
            </el-input>
            <el-input v-model="queryForm.stuName" @keyup.enter.native="handleFilter" style="width: 200px" placeholder="姓名" clearable>
            </el-input>
            <el-date-picker type="date" placeholder="开始日期" v-model="queryForm.startTime" value-format="yyyy-MM-dd" style="width:200px;"></el-date-picker>
            <el-date-picker type="date" placeholder="结束日期" v-model="queryForm.endTime" value-format="yyyy-MM-dd" style="width:200px;"></el-date-picker>
            <el-select v-model="queryForm.auditState" placeholder="审核状态" style="width: 180px" clearable>
                <el-option v-for="(item, index) in comboData.auditState" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                </el-option>
            </el-select>
            <el-button @click="handleFilter" type="gray" style="margin-left: 10px"><i class="el-icon-search"></i>&nbsp;查询</el-button>
            <el-button @click="handleReset" type="gray"><i class="el-icon-refresh"></i>&nbsp;重置</el-button>
            <el-button @click="addRec" type="success"><i class="el-icon-circle-plus-outline"></i>&nbsp;申请</el-button>
        </div>

        <el-table :data="tableData" @current-change="handleCurrentChange" v-loading.body="tableLoading"
            :cell-style="handleCellStyle"
            element-loading-text="信息加载中" highlight-current-row border style="width: 100%" :height="mainTableHeight" ref="mainTable">
            <el-table-column label="序号" width="50" align="center">
                <template slot-scope="scope">
                    <span>{{ (currentPage - 1) * limit + scope.$index + 1 }}</span>
                </template>
            </el-table-column>
            <el-table-column label="学号" prop="stuCode" align="center" width="150px"></el-table-column>
            <el-table-column label="姓名" prop="stuName" align="center" width="150px"></el-table-column>
            <el-table-column label="异动类型" prop="changeName" align="center" width="100px"></el-table-column>
            <el-table-column label="异动原因" prop="reasonName" align="center" width="300px"></el-table-column>
            <el-table-column label="异动日期" prop="changeTime" align="center" width="100px"></el-table-column>
            <el-table-column label="异动说明" prop="desc" align="center"></el-table-column>
            <el-table-column label="提交状态" prop="submitState" :formatter="submitStateFormatter" align="center" width="80px"></el-table-column>
            <el-table-column label="审核状态" prop="auditState" :formatter="auditStateFormatter" align="center" width="80px"></el-table-column>
            <el-table-column label="操作" align="center" width="250px">
                <template slot-scope="scope">
                    <el-button v-if="scope.row.submitState == '0'" size="small" @click="modRec(scope.row);" type="warning">
                        <i class="el-icon-edit"></i>&nbsp;编辑
                    </el-button>
                    <el-button v-if="scope.row.submitState == '0'" size="small" @click="delRec(scope.row);" type="danger">
                        <i class="el-icon-delete"></i>&nbsp;删除
                    </el-button>
                    <el-button v-if="scope.row.submitState=='1' && scope.row.auditAuth=='0'" size="small" @click="showDetailInfo(scope.row);" type="info">
                        <i class="el-icon-tickets"></i>&nbsp;详情
                    </el-button>
                    <el-button v-if="scope.row.auditAuth == '1'" size="small" @click="auditRec(scope.row);" type="primary">
                        <i class="el-icon-edit-outline"></i>&nbsp;审核
                    </el-button>
                    <el-button v-if="scope.row.submitState=='1' || scope.row.auditState!=''" size="small" @click="showAuditList(scope.row);">
                        <i class="el-icon-document"></i>&nbsp;审核信息
                    </el-button>
                </template>
            </el-table-column>
        </el-table>
        <div class="pagination-container">
            <el-pagination @size-change="handleSizeChange" @current-change="handlePageChange" :current-page.sync="currentPage"
                :page-sizes="[10, 20, 50]" :page-size="limit" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
        </div>

        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" @closed="closeDialog" width="900px" top="150px">
            <el-form ref="changeStatusForm" :model="curdForm" label-width="120px" label-position="left" width="100%" :rules="curdRules">
                <el-form-item label="编号" prop="id" v-show="false">
                    <el-input v-model="curdForm.id"></el-input>
                </el-form-item>
                <el-form-item label="学生" prop="stuInfo" v-show="teaAuthVisible">
                    <el-autocomplete class="inline-input" v-model="stuInfo" :fetch-suggestions="querySearchStu" placeholder="可输入学号或姓名搜索学生"
                          :trigger-on-focus="false" @clear="clearSelectStu" clearable style="width:100%;"></el-autocomplete>
                </el-form-item>
                <el-row v-show="stuAuthVisible">
                    <el-col :span="12">
                        <el-form-item label="学号" prop="stuCode">
                            {{ curdForm.stuCode }}
                            <el-input v-model="curdForm.stuCode" v-show="false"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="姓名" prop="stuName">
                            {{ curdForm.stuName }}
                            <el-input v-model="curdForm.stuName" v-show="false"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="异动类型">
                            转专业
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="异动日期" prop="changeTime">
                            <el-date-picker type="date" placeholder="异动日期" v-model="curdForm.changeTime" style="width:100%;"></el-date-picker>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="异动原因" prop="reasonCode">
                            <el-select v-model="curdForm.reasonCode" filterable placeholder="请选择异动原因" style="width:100%;">
                                <el-option v-for="item in comboData.reasonCode" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="原专业码" prop="oriMajorCode" v-show="false">
                            <el-input v-model="curdForm.oriMajorCode"></el-input>
                        </el-form-item>
                        <el-form-item label="原专业" prop="oriMajorName">
                            {{ curdForm.oriMajorName }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="现专业" prop="newMajorCode">
                            <el-select v-model="curdForm.newMajorCode" filterable placeholder="请选择现专业" style="width:100%" @change="loadClassCombo">
                                <el-option v-for="item in comboData.major" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="原班级码" prop="oriClassCode" v-show="false">
                            <el-input v-model="curdForm.oriClassCode"></el-input>
                        </el-form-item>
                        <el-form-item label="原班级" prop="oriClassName">
                            {{ curdForm.oriClassName }}
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="现班级" prop="newClassCode">
                            <el-select v-model="curdForm.newClassCode" filterable placeholder="请选择现班级" style="width:100%">
                                <el-option v-for="item in comboData.class" :key="item.comboValue" :label="item.comboName" :value="item.comboValue">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-form-item label="异动说明" prop="desc">
                    <el-input v-model="curdForm.desc" placeholder="请填写异动说明" autoComplete="on" type="textarea"
                        :rows="5" show-word-limit maxlength="500"></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer" style="margin-top: 10px">
                <el-button type="primary" :loading="formSubmiting" @click="saveRec">保 存</el-button>
                <el-button type="warning" :loading="formSubmiting" @click="saveAndSubmitRec">提 交</el-button>
                <el-button @click="dialogVisible = false">取 消</el-button>
            </div>
        </el-dialog>

        <el-dialog :title="detailDialogTitle" :visible.sync="detailDialogVisible" v-if="detailDialogVisible" width="900px" :top="detailDialogTop">
            <el-form label-width="120px" label-position="left" width="100%">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="学号">{{ selectRowData.stuCode }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="姓名">{{ selectRowData.stuName }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="异动类型">{{ selectRowData.changeName }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="异动日期">{{ selectRowData.changeTime }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="异动原因">{{ selectRowData.reasonName }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="异动去向学校" v-show="selectRowData.changeCode=='11'">
                            {{ selectRowData.newSchooleCode }}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="原专业">{{ selectRowData.oriMajorName }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="现专业">
                            {{ selectRowData.newMajorName }}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="原班级">{{ selectRowData.oriClassName }}</el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="现班级">
                            {{ selectRowData.newClassName }}
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="24">
                        <el-form-item label="异动说明">{{ selectRowData.desc }}</el-form-item>
                    </el-col>
                </el-row>
                <el-row v-show="auditAreaVisible">
                    <el-col :span="24">
                        <audit ref="audit" :itemCode="auditParam" :relatedCode="selectRowData.id" :auditLevel="selectRowData.auditLevel"
                            @auditCallback="auditCallback"></audit>
                    </el-col>
                </el-row>
            </el-form>
        </el-dialog>

        <el-dialog title="审核信息" :visible.sync="auditListDialogVisible" v-if="auditListDialogVisible" width="900px" top="150px">
            <div style="height:550px;">
                <auditList ref="auditList" :relatedCode="selectRowData.id" :listHeight="450"></auditList>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import { confirmMsg, showNotify } from "utils/message";
    import audit from 'views/audit/audit.vue';
    import auditList from 'views/audit/auditList.vue';

    export default {
        components: {
            audit,
            auditList,
        },
        data() {
            return {
				userRole: null,
				stuAuthVisible: false,
				teaAuthVisible: false,
                comboData: {
                    reasonCode: null,
                    major: null,
                    class: null,
                    auditState: null,
                },
                queryForm: {
                    pageNum: 1,
                    rowNum: 10,
                    stuCode: null,
                    stuName: null,
                    changeCode: '06',
                    startTime: null,
                    endTime: null,
                    itemCode: null,
                    auditState: null,
                },
                tableData: [],
                currentPage: 1,
                limit: 10,
                total: null,
                tableLoading: true,
                selectRowData: {},
                mainTableHeight: 500,
                dialogTitle: "",
                dialogVisible: false,
                students: [],
                stuInfo: null,
                curdForm: {
                    id: '',
                    stuCode: '',
                    stuName: '',
                    changeCode: '06',
                    reasonCode: '',
                    oriSchoolCode: '',
                    newSchoolCode: '',
                    oriMajorCode: '',
                    oriMajorName: '',
                    newMajorCode: '',
                    newMajorName: '',
                    oriClassCode: '',
                    oriClassName: '',
                    newClassCode: '',
                    newClassName: '',
                    submitState: '',
                    desc: '',
                    changeTime: '',
                },
                curdRules: {
                    stuInfo: [{
                        required: true,
                        validator: (rule, value, callback) => {
                            let isExist = false;

                            for(let i=0; i<this.students.length; i++){
                                if(this.students[i].value == this.stuInfo){
                                    this.curdForm.stuCode = this.students[i].stuCode;
                                    this.curdForm.stuName = this.students[i].stuName;
                                    this.curdForm.oriMajorCode = this.students[i].majorCode;
                                    this.curdForm.oriMajorName = this.students[i].majorName;
                                    this.curdForm.oriClassCode = this.students[i].classCode;
                                    this.curdForm.oriClassName = this.students[i].className;
                                    isExist = true;

                                    break;
                                }
                            }

                            if(isExist == false){
                                this.curdForm.stuCode = '';
                                this.curdForm.stuName = '';
                                this.curdForm.oriMajorCode = '';
                                this.curdForm.oriMajorName = '';
                                this.curdForm.oriClassCode = '';
                                this.curdForm.oriClassName = '';
                                callback(new Error("学生不存在"));
                            }else{
                                callback();
                            }
                        },
                        change: "blur",
                    }],
                    changeCode: [{
                            required: true,
                            message: "请选择异动类型",
                            trigger: ["blur", "change"],
                        }
                    ],
                    reasonCode: [{
                            required: true,
                            message: "请选择异动原因",
                            trigger: ["blur", "change"],
                        }
                    ],
                    changeTime: [{
                            required: true,
                            message: "请选择异动日期",
                            trigger: ["blur", "change"],
                        }
                    ],
                    newMajorCode: [{
                            required: true,
                            message: "请选择现专业",
                            trigger: ["blur", "change"],
                        }
                    ],
                    newClassCode: [{
                            required: true,
                            message: "请选择现班级",
                            trigger: ["blur", "change"],
                        }
                    ],
                },
                formSubmiting: false,
                detailDialogTitle: '',
                detailDialogTop: '150px',
                detailDialogVisible: false,
                auditAreaVisible: false,
                auditListDialogVisible: false,
                auditParam: null,
            };
        },
		created(){
		    this.queryUserInfo();
		},
        mounted() {
            this.initCombo();
            //this.queryAuditParam();
            this.auditParam = 'XJYD';
            this.queryForm.itemCode = this.auditParam;
            this.queryList();

            this.$nextTick().then(() => {
                //this.$refs.table.$el.offsetTop：表格距离浏览器的高度
                //最后数字表示要调整的表格距离底部的高度（如预留分页组件的高度）
                this.mainTableHeight = window.innerHeight - this.$refs.mainTable.$el.offsetTop - 145;

                // 监听窗口大小变化
                let self = this;
                window.onresize = function() {
                    self.mainTableHeight = window.innerHeight - self.$refs.mainTable.$el.offsetTop - 145;
                };
            });
        },
        methods: {
            //查询审核调用参数
            /* queryAuditParam(){
                const pageName = this.$route.path.substring(this.$route.path.lastIndexOf("/")+1);

                this.$api.common.audit.auditParam({
                    data: { pageName: pageName },
                }).then((res) => {
                    this.auditParam = res.data.data.auditParam;
                    this.queryForm.itemCode = this.auditParam;
                    this.queryList();
                }).catch((err) => {
                    console.log(err);
                });
            }, */
			queryUserInfo() {
			    this.$api.system.basic.userInfo({}).then((res) => {
                    const userInfo = res.data.data;
                    
			        if (userInfo) {
			            let roleInfo = userInfo.roles;

			            for (var roleCode in roleInfo) {
			                // console.log("键：" + roleCode + ",值："+ roleInfo[roleCode]);
			                this.userRole = roleInfo[roleCode];
			            }

                        if(this.userRole == '学生'){
			                this.stuAuthVisible = true;
                            this.curdForm.stuCode = userInfo.phone;
                            //this.curdForm.stuCode = '20215060010101';
                            this.curdForm.stuName = userInfo.name;
                            //this.curdForm.stuName = '何睿';
                            this.stuInfo = this.curdForm.stuName + ' - ' + this.curdForm.stuCode;
			            }else{
			                this.teaAuthVisible = true;
			            }
			        } else {
			            this.userRole = '访客';
			            this.$router.push('/login');
			        }
			    }).catch((err) => {
			        console.log(err);
			    });
			},
            submitStateFormatter(row){
                return row.submitState === '1' ? '已提交' : '未提交';
            },
            auditStateFormatter(row){
                let str = '';

                if(row.auditState==='1'){
                    str = '通过';
                }else if(row.auditState==='2'){
                    str = '驳回';
                }else{
                   if(row.submitState === '1'){
                       if(row.auditLevel === '1'){
                           str = '待审核';
                       }else{
                           str = '审核中';
                       }
                   }else{
                       str = '未提交';
                   }
                }

                return str;
            },
            handleCellStyle({row, column, rowIndex, columnIndex}){
                let cellStyle;

                if(columnIndex === 8){
                    switch (row.auditState) {
                        case '1':
                            cellStyle = 'color: #00FF40 !important;';
                            break;
                        case '2':
                            cellStyle = 'color: #FE2E2E !important;';
                            break;
                        default:
                            cellStyle = '';
                    }

                    return cellStyle;
                }
            },
            queryList() {
                this.tableLoading = true;
                this.queryForm.pageNum = this.currentPage;
                this.queryForm.rowNum = this.limit;

                this.$api.student.status.list({
                    data: this.queryForm,
                }).then((response) => {
                    this.total = response.data.data.total;
                    this.tableData = response.data.data.list;
                    this.tableLoading = false;
                }).catch((error) => {
                    this.tableLoading = false;
                    console.log(error);
                });
            },
            handleFilter() {
                this.currentPage = 1;
                this.queryList();
            },
            handleReset() {
                this.limit = 10;
                this.currentPage = 1;
                if(this.teaAuthVisible){
                    this.queryForm.stuCode = null;
                    this.queryForm.stuName = null;
                }
                this.queryForm.startTime = null;
                this.queryForm.endTime = null;
                this.queryForm.auditState = null;
                this.tableLoading = false;
                this.queryList();
            },
            handlePageChange(val) {
                this.currentPage = val;
                this.queryList();
            },
            handleCurrentChange(val) {
               this.selectRowData = val;
            },
            handleSizeChange(val) {
                this.limit = val;
                this.currentPage = 1;
                this.queryList();
            },
            initCombo() {
                this.$api.student.status.initCombo({}).then((res) => {
                    this.comboData.changeCode = res.data.data.changeCodeComboData;
                    this.comboData.major = res.data.data.majorComboData;
                    this.comboData.class = res.data.data.classComboData;
                    this.students = res.data.data.stuData;
                    this.comboData.auditState = res.data.data.auditStateComboData;

                    //异动原因处理
                    const allReasonCodeOption = res.data.data.reasonCodeComboData;
                    const reasonCodeArray = ['04','05','21','22','99'];
                    let tempReasonOption = [];
                    allReasonCodeOption.forEach(function(option) {
                        if(reasonCodeArray.indexOf(option.comboValue) > -1){
                            tempReasonOption.push(option);
                        }
                    });
                    this.comboData.reasonCode = tempReasonOption;
                }).catch((err) => {
                    console.log(err);
                });
            },
            querySearchStu(queryString, cb){
                let students = this.students;
                let results = queryString ? students.filter(this.createFilter(queryString)) : students;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilter(queryString) {
                return (student) => {
                    return (student.value.toLowerCase().indexOf(queryString.toLowerCase()) > -1);
                };
            },
            handleSelectStu(item){
                this.curdForm.stuCode = item.stuCode;
                this.curdForm.stuName = item.stuName;
                this.curdForm.oriMajorCode = item.majorCode;
                this.curdForm.oriMajorName = item.majorName;
                this.curdForm.oriClassCode = item.classCode;
                this.curdForm.oriClassName = item.className;
            },
            clearSelectStu(){
                document.activeElement.blur();
            },
            loadClassCombo(){
                this.$api.student.status.loadClassComboByMajor({
                    data: { majorCode: this.curdForm.newMajorCode },
                }).then((res) => {
                    this.comboData.class = res.data.data.classComboData;
                }).catch((err) => {
                    console.log(err);
                });
            },
            addRec(){
                this.dialogTitle = "新建";
                this.dialogVisible = true;

                if(this.userRole == '学生'){
                    for(let i=0; i<this.students.length; i++){
                        if(this.students[i].stuCode == this.curdForm.stuCode){
                            this.curdForm.oriMajorCode = this.students[i].majorCode;
                            this.curdForm.oriMajorName = this.students[i].majorName;
                            this.curdForm.oriClassCode = this.students[i].classCode;
                            this.curdForm.oriClassName = this.students[i].className;
                            break;
                        }
                    }

                    this.curdForm.id = '';
                    this.curdForm.desc = '';
                }else{
                    if(this.$refs['changeStatusForm'] !== undefined){
                        this.$refs['changeStatusForm'].resetFields();
                    }

                    this.stuInfo = '';
                }

                this.curdForm.submitState = '0';
                this.curdForm.newMajorCode = '';
                this.curdForm.newClassCode = '';
                this.curdForm.changeTime = this.getCurrentFormatDate();
            },
            modRec(rowData) {
                this.selectRowData = rowData;

                if (this.selectRowData == null) {
                    this.$alert("请先选择一条记录", "提示", {
                        confirmButtonText: "确定",
                    });

                    return;
                }

                this.dialogTitle = "编辑";
                this.dialogVisible = true;
                this.$nextTick(() => {
                    this.curdForm.id = this.selectRowData.id;
                    this.stuInfo = this.selectRowData.stuName + ' - ' + this.selectRowData.stuCode;
                    this.curdForm.stuCode = this.selectRowData.stuCode;
                    this.curdForm.stuName = this.selectRowData.stuName;
                    this.curdForm.changeCode = this.selectRowData.changeCode;
                    this.curdForm.changeTime = this.selectRowData.changeTime;
                    this.curdForm.oldMajorCode = this.selectRowData.oldMajorCode;
                    this.curdForm.oldMajorName = this.selectRowData.oldMajorName;
                    this.curdForm.newMajorCode = this.selectRowData.newMajorCode;
                    this.curdForm.oldClassCode = this.selectRowData.oldClassName;
                    this.curdForm.oldClassName = this.selectRowData.oldClassCode;
                    this.curdForm.newClassCode = this.selectRowData.newClassCode;
                    this.curdForm.desc = this.selectRowData.desc;
                    this.curdForm.submitState = this.selectRowData.submitState;
                });
            },
            saveRec() {
                this.formSubmiting = true;

                this.$refs['changeStatusForm'].validate((valid) => {
                    if (valid) {
                        this.$api.student.status.save({
                            data: this.curdForm,
                        }).then((response) => {
                            let state = response.data.data.state;
                            let msg = response.data.data.msg;

                            if (state == 'Success') {
                                showNotify('成功', msg ? msg : "保存成功", 'success', 1500);

                                this.currentPage = 1;
                                this.limit = 10;
                                this.queryList();
                                this.closeDialog();
                            }else{
                                showNotify('失败', msg ? msg : '保存失败', 'error', 3000);
                            }
                        }).catch((error) => {
                            showNotify('错误', error, 'error', 3000);
                        });
                    } else {
                        return false;
                    }
                });

                this.formSubmiting = false;
            },
            saveAndSubmitRec(){
                confirmMsg('提交后将无法再修改学籍异动信息，是否继续？').then(() => {
                    this.curdForm.submitState = '1';
                    this.saveRec();
                });
            },
            submitRec(rowData){
                confirmMsg('提交后将无法再修改学籍异动信息，是否继续？').then(() => {
                    this.$api.student.status.submit({
                        data: {
                            id: rowData.id
                        },
                    }).then((response) => {
                        let state = response.data.data.state;

                        if (state == 'Success') {
                            showNotify('成功', '提交成功', 'success', 1500);

                            this.currentPage = 1;
                            this.limit = 10;
                            this.queryList();
                        }else{
                            showNotify('失败', '提交失败', 'error', 3000);
                        }
                    }).catch((error) => {
                        showNotify('错误', error, 'error', 3000);
                    });
                });
            },
            delRec(rowData){
                confirmMsg('是否确定要删除转专业申请信息？').then(() => {
                    this.curdForm.id = rowData.id;

                    this.$api.student.status.del({
                        data: this.curdForm,
                    }).then((response) => {
                        let state = response.data.data.state;

                        if (state == 'Success') {
                            showNotify('成功', '删除成功', 'success', 1500);

                            this.currentPage = 1;
                            this.limit = 10;
                            this.queryList();
                        }else{
                            showNotify('失败', '删除失败', 'error', 3000);
                        }
                    }).catch((error) => {
                        showNotify('错误', error, 'error', 3000);
                    });
                });
            },
            closeDialog() {
                this.dialogVisible = false;
            },
            showDetailInfo(rowData){
                this.selectRowData = rowData;
                this.detailDialogTitle = '详情';
                this.detailDialogTop = '250px';
                this.detailDialogVisible = true;
                this.auditAreaVisible = false;
            },
            auditRec(rowData){
                this.selectRowData = rowData;
                this.detailDialogTitle = '审核';
                this.detailDialogTop = '150px';
                this.detailDialogVisible = true;
                this.auditAreaVisible = true;
            },
            auditCallback(auditInfo){
                this.detailDialogVisible = false;
                auditInfo.changeCode = this.selectRowData.changeCode;
                auditInfo.stuCode = this.selectRowData.stuCode;
                auditInfo.newMajorCode = this.selectRowData.newMajorCode;
                auditInfo.newClassCode = this.selectRowData.newClassCode;

                this.updateStuState(auditInfo);
            },
            updateStuState(auditInfo){
                this.$api.student.status.updateAuditState({
                    data: auditInfo,
                }).then((response) => {
                    let state = response.data.data.state;

                    if(state == 'Success'){
                        //更新学生信息
                        if(response.data.data.updateStuInfo == 'true'){
                            for(let i=0; i<this.students.length; i++){
                                if(this.students[i].stuCode == this.selectRowData.stuCode){
                                    this.students[i].majorCode = this.selectRowData.newMajorCode;
                                    this.students[i].majorName = this.selectRowData.newMajorName;
                                    this.students[i].classCode = this.selectRowData.newClassCode;
                                    this.students[i].className = this.selectRowData.newClassName;

                                    break;
                                }
                            }
                        }
                    }else{
                        showNotify('失败', '学籍信息更新失败', 'error', 3000);
                    }

                    this.queryList();
                }).catch((error) => {
                    showNotify('错误', error, 'error', 3000);
                });
            },
            showAuditList(rowData){
                this.selectRowData = rowData;
                this.auditListDialogVisible = true;
            },
            getCurrentFormatDate(){
                var date = new Date();
                var seperator1 = "-";
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var strDate = date.getDate();
                if (month >= 1 && month <= 9) {
                    month = "0" + month;
                }
                if (strDate >= 0 && strDate <= 9) {
                    strDate = "0" + strDate;
                }
                var currentdate = year + seperator1 + month + seperator1 + strDate;
                return currentdate;
            },
        },
    };
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// changeMajor.vue?dc78a84e